import { SmartFlow } from '../Chatbot/icons/Icons'
import { useWorkspaceService } from '../../../_services/WorkspaceService'
import { IconDeviceDesktop, IconX } from '@tabler/icons-react'

interface WorkspaceTabProps {
  item: any
  active: boolean
  index: number
  handleOnRemoveWorkspace: (item: any) => void
  workspacesId: string
  setCurrentApp: (app: { workspaceId: string | null; app: any }) => void
}

const WorkspaceTab = ({
  item,
  active,
  index,
  handleOnRemoveWorkspace,
  workspacesId,
  setCurrentApp
}: WorkspaceTabProps) => {
  const { updateActiveWorkspace } = useWorkspaceService()

  if (!item || !Object.keys(item).length) {
    return
  }

  return (
    <>
      <div
        key={`${item.id}_${index + 1}_application`}
        data-tip
        data-for={`tab-app-${item.id}`}
        data-testid={`tabApp-${item.id}`}
        data-active={active}
        className={`relative flex flex-row items-center border-l border-r border-[var(--gray-200)] rounded-[2px] overflow-hidden whitespace-nowrap cursor-pointer h-[40px] px-[10px] w-auto min-w-[150px] flex-shrink-0 ${
          active ? 'bg-[var(--color-primary)]' : 'bg-[transparent] hover:bg-[var(--gray-100)]'
        }`}>
        <div
          onClick={() => {
            setCurrentApp({ workspaceId: null, app: null })
            updateActiveWorkspace(workspacesId)
          }}
          className="w-auto h-full items-center flex flex-row flex-1 min-w-0 group hover:text-[var(--gray-700)]">
          <div className="h-[30px] w-[30px] flex justify-center items-center [&>svg]:transition-[stroke] [&>svg]:duration-200">
            {item.icon === 'smartflow' ? (
              <SmartFlow size={22} color={active ? 'var(--white)' : 'var(--color-info)'} />
            ) : (
              <IconDeviceDesktop size={22} color={active ? 'var(--white)' : 'var(--gray-400'} />
            )}
          </div>
          <div
            id={`ws-${workspacesId}`}
            data-tooltip-id={`ws-${workspacesId}`}
            className={`leading-5 text-sm font-normal whitespace-nowrap overflow-hidden text-ellipsis m-[10px] mr-[30px] block ${
              active ? 'text-white group-hover:text-white' : 'text-[var(--gray-500)]'
            }`}>
            {item?.name}
          </div>
        </div>

        {item?.name !== 'Primary Workspace' && (
          <>
            <IconX
              className={`pointer absolute right-[0.3rem] w-[22px] transition-colors ${
                active
                  ? 'text-white hover:bg-[var(--color-primary-dark)] hover:text-white'
                  : 'text-[var(--gray-300)] hover:bg-[var(--gray-200)] hover:text-[var(--icon-muted)]'
              } hover:cursor-pointer`}
              size={22}
              onClick={(e: React.MouseEvent) => {
                e.stopPropagation() // Prevent drag when clicking close
                handleOnRemoveWorkspace(item)
              }}
              onPointerDown={(e: React.PointerEvent) => e.stopPropagation()} // Prevent drag initiation
              data-testid={`remove-workspace-${item.id}`}
              data-closeappid={`${item.name}_${index + 1}_close`}
            />
          </>
        )}
      </div>
    </>
  )
}

export default WorkspaceTab
